import { render, staticRenderFns } from "./TenderTabsContainer.vue?vue&type=template&id=7d88a864&scoped=true&"
import script from "./TenderTabsContainer.vue?vue&type=script&lang=js&"
export * from "./TenderTabsContainer.vue?vue&type=script&lang=js&"
import style0 from "./TenderTabsContainer.vue?vue&type=style&index=0&id=7d88a864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d88a864",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d88a864')) {
      api.createRecord('7d88a864', component.options)
    } else {
      api.reload('7d88a864', component.options)
    }
    module.hot.accept("./TenderTabsContainer.vue?vue&type=template&id=7d88a864&scoped=true&", function () {
      api.rerender('7d88a864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/TenderTabsContainer.vue"
export default component.exports